export default __webpack_public_path__ + "static/media/ic_invoice.0f0dce65.svg";